<div class="listview container-fluid">
  <div class="row">
    <div [class]="canAdminInquiry ? 'col-xxl-8' : 'col-xxl-12'">
      <button
        type="button"
        class="btn btn-primary btn-full-width mb-4 align-item-center"
        (click)="openNewStaffRequestModal()"
      >
        <i class="fa-solid fa-plus headline-20 me-2"></i>
        <span class="headline-20">{{ 'inquiry.new' | translate }}</span>
      </button>
      <base-customer-dashboard-operations
        [active]="dashboardData?.assignments?.active ?? 0"
        [planned]="dashboardData?.assignments?.planned ?? 0"
        [isButtonVisible]="canAdminAssignments"
      ></base-customer-dashboard-operations>
      <div class="teaser">
        <base-dashboard-card-header
          header="dashboardInfo.missedCustomerSpecifications"
          [amount]="dashboardData?.unsignedContracts?.cust ?? 0"
          buttonLabel="action.showMore"
          [isButtonAllowed]="canAdminAssignments"
          [showBorder]="false"
          link="external-employees/list"
          [queryParams]="{ openContract: 'customer' }"
        ></base-dashboard-card-header>
      </div>
      <div class="teaser">
        <base-dashboard-card-header
          [amount]="dashboardData?.inquiries?.unpublished ?? 0"
          header="dashboardInfo.notPublishedInquiries"
          [showBorder]="false"
          [isButtonAllowed]="canAdminInquiry"
          buttonLabel="action.showMore"
          link="inquiries/list"
          [queryParams]="{ status: '1' }"
        ></base-dashboard-card-header>
        <base-customer-dashboard-unpublished-inquiries
          *ngIf="unpublishedInquiries?.length"
          [unpublishedInquiries]="unpublishedInquiries"
        ></base-customer-dashboard-unpublished-inquiries>
      </div>
      <div
        class="d-flex flex-column flex-lg-row justify-content-between gap-lg-4"
        *ngIf="canAdminAssignments"
      >
        <div class="teaser w-100">
          <base-dashboard-card-header
            [amount]="upcomingEPAssignmentsTotalCount"
            header="upcomingEP"
            [showBorder]="false"
            [isButtonAllowed]="canAdminInquiry"
            buttonLabel="action.showMore"
            link="external-employees/list"
            [queryParams]="{ status: 'planned,active', order: 'ep,ASC' }"
          ></base-dashboard-card-header>
          <hr />
          <ng-container *ngIf="upcomingEPAssignments.length; else noEPDates">
            <div
              class="d-flex align-items-center justify-content-between gap-3"
              *ngFor="let item of upcomingEPAssignments"
            >
              <div class="d-flex align-items-center justify-content-between gap-2">
                <base-avatar
                  [size]="avatarSizes.medium"
                  [image]="item.profile.avatar || ''"
                ></base-avatar>
                <div>
                  <div class="d-flex flex-column">
                    <p
                      class="m-0 fw-bold"
                      baseTruncate
                    >
                      {{ item.profile.firstName }} {{ item.profile.lastName }}
                    </p>
                    <p class="m-0">{{ item.pspBranch.name }}</p>
                  </div>
                </div>
              </div>
              <p class="m-0">{{ item.ep | baseFormatDate }}</p>
            </div>
          </ng-container>
          <ng-template #noEPDates>
            <p>{{ 'noEPDates' | translate }}</p>
          </ng-template>
        </div>
        <div class="teaser w-100">
          <base-dashboard-card-header
            [amount]="upcomingMLPAssignmentsTotalCount"
            header="upcomingMLP"
            [showBorder]="false"
            [isButtonAllowed]="canAdminInquiry"
            buttonLabel="action.showMore"
            link="external-employees/list"
            [queryParams]="{ status: 'planned,active', order: 'mlp,ASC' }"
          ></base-dashboard-card-header>
          <hr />
          <ng-container *ngIf="upcomingMLPAssignments.length; else noMLPDates">
            <div
              class="d-flex align-items-center justify-content-between gap-3"
              *ngFor="let item of upcomingMLPAssignments"
            >
              <div class="d-flex align-items-center justify-content-between gap-2">
                <base-avatar
                  [size]="avatarSizes.medium"
                  [image]="item.profile.avatar || ''"
                ></base-avatar>
                <div>
                  <div class="d-flex flex-column">
                    <p
                      class="m-0 fw-bold"
                      baseTruncate
                    >
                      {{ item.profile.firstName }} {{ item.profile.lastName }}
                    </p>
                    <p class="m-0">{{ item.pspBranch.name }}</p>
                  </div>
                </div>
              </div>
              <p class="m-0">{{ item.mlp | baseFormatDate }}</p>
            </div>
          </ng-container>
          <ng-template #noMLPDates>
            <p>{{ 'noMLPDates' | translate }}</p>
          </ng-template>
        </div>
      </div>
    </div>

    <div
      class="col-xxl-4 d-flex flex-column"
      *ngIf="canAdminInquiry"
    >
      <div class="teaser">
        <base-dashboard-card-header
          header="dashboardInfo.newOffers"
          [showBorder]="false"
          icon="fa-arrows-rotate"
          (buttonClick)="onOfferRefresh()"
        ></base-dashboard-card-header>
      </div>
      <div class="row">
        <div
          class="col-md-6 col-xxl-12"
          *ngFor="let offer of customerOffers; let i = index"
        >
          <base-customer-dashboard-offer-card
            [isRecent]="!i"
            [offer]="offer"
            [routerLink]="
              offer.unlimited
                ? '/inquiries/' + offer.inquiry.id + '/unlimited/offers'
                : '/inquiries/' + offer.inquiry.id + '/offers'
            "
          ></base-customer-dashboard-offer-card>
        </div>
        <base-empty-list-row
          message="dashboardInfo.noOffers"
          [largeImage]="true"
          *ngIf="!customerOffers?.length"
        ></base-empty-list-row>
      </div>
    </div>
  </div>
</div>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [isInquiryDefaultFilter]="true"
    [modalRef]="modalRef"
  ></base-customer-staff-request-modal>
</ng-template>
